import { parseFetch } from "../utils";
import { v4 as uuidv4 } from "uuid";
import { BehaviorSubject } from "rxjs";
export class ManagerVehicles {
    constructor() {
        var _a;
        this.KEY_STORE = 'vehicles';
        this.SELECTED_STORE = 'selectedVehicle';
        console.info('Creating Instance of ManagerVehicles');
        this.vehicles = (_a = this.loadVehicles()) !== null && _a !== void 0 ? _a : [];
        this.selected$ = new BehaviorSubject(this.selected);
        this.vehicles$ = new BehaviorSubject(this.vehicles);
    }
    get selected() {
        return this.vehicles.find(v => !!v.selected);
    }
    static getInstance() {
        if (!ManagerVehicles.instance) {
            ManagerVehicles.instance = new ManagerVehicles();
        }
        return ManagerVehicles.instance;
    }
    addVehicle(vehicle, selected = false, isOrder = false) {
        const { vin, descMarca, descModelo } = vehicle;
        this.vehicles.forEach(v => v.selected = false);
        const find = this.vehicles.find(d => {
            if (vin) {
                return !!d.vin && d.vin === vin;
            }
            else {
                return d.descMarca === descMarca && d.descModelo === descModelo;
            }
        });
        if (find) {
            find.selected = selected;
        }
        else {
            this.vehicles.push(Object.assign({ uuid: uuidv4(), isOrder,
                selected }, vehicle));
        }
        this.persist();
    }
    deleteVehicle(vehicle) {
        const index = this.vehicles.findIndex((v) => {
            return vehicle.placa === v.placa;
        });
        this.vehicles.splice(index, 1);
        this.persist();
    }
    async searchByPlaca(placa) {
        try {
            const response = await parseFetch({
                method: 'POST',
                url: '/backend/servicio/agregar-vehiculo/',
                data: {
                    placa: placa.toUpperCase()
                }
            });
            this.addVehicle(response, true);
        }
        catch (e) {
        }
    }
    setSelected(v) {
        this.vehicles.forEach(d => {
            if (v.vin) {
                if (d.vin && v.vin) {
                    d.selected = d.vin.trim() === v.vin.trim() && !v.selected;
                }
                else {
                    d.selected = false;
                }
            }
            else {
                d.selected = d.descModeloTASA === v.descModeloTASA && !d.vin;
            }
        });
        this.selected$.next(this.selected$);
        this.persist();
    }
    persist() {
        localStorage.setItem(this.KEY_STORE, JSON.stringify(this.vehicles));
        const selected = this.selected;
        if (selected) {
            localStorage.setItem(this.SELECTED_STORE, JSON.stringify(selected));
        }
        else {
            localStorage.removeItem(this.SELECTED_STORE);
        }
        this.selected$.next(this.selected);
        this.vehicles$.next(this.vehicles);
    }
    loadVehicles() {
        try {
            const parsed = JSON.parse(localStorage.getItem(this.KEY_STORE));
            return parsed ? parsed : [];
        }
        catch (e) {
            return [];
        }
    }
}
